import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WaveWinnersDropHeaderVoter from "./WaveWinnersDropHeaderVoter";
interface WaveWinnersDropHeaderVotersProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderVoters(t0) {
  const $ = _c(25);
  const {
    winner
  } = t0;
  const hasUserVoted = winner.drop.context_profile_context?.rating !== undefined && winner.drop.context_profile_context?.rating !== 0;
  const userVote = winner.drop.context_profile_context?.rating ?? 0;
  const isNegativeVote = userVote < 0;
  let t1;
  if ($[0] !== isNegativeVote || $[1] !== winner.place) {
    const topThreeRankStyles = {
      1: "tw-text-[#E8D48A]",
      2: "tw-text-[#DDDDDD]",
      3: "tw-text-[#CD7F32]"
    };
    const getVoteStyle = (rank, isNegative) => {
      if (rank && rank <= 3) {
        return topThreeRankStyles[rank];
      }
      if (isNegative) {
        return "tw-bg-gradient-to-r tw-from-red tw-to-red tw-bg-clip-text tw-text-transparent";
      }
      return "tw-bg-gradient-to-r tw-from-emerald-400 tw-to-emerald-500 tw-bg-clip-text tw-text-transparent";
    };
    t1 = getVoteStyle(winner.place, isNegativeVote);
    $[0] = isNegativeVote;
    $[1] = winner.place;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rankStyle = t1;
  let t2;
  if ($[3] !== winner) {
    t2 = winner.drop.top_raters.map((voter, index) => <WaveWinnersDropHeaderVoter voter={voter} winner={winner} index={index} key={voter.profile.handle} />);
    $[3] = winner;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="tw-flex tw-items-center -tw-space-x-2">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== winner.drop.raters_count) {
    t4 = formatNumberWithCommas(winner.drop.raters_count);
    $[7] = winner.drop.raters_count;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = winner.drop.raters_count === 1 ? "voter" : "voters";
  let t6;
  if ($[9] !== t5) {
    t6 = <span className="tw-text-iron-500 tw-font-normal">{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <span className="tw-text-white tw-font-bold tw-text-sm">{t4}{" "}{t6}</span>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-2">{t3}{t7}</div>;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== hasUserVoted || $[18] !== rankStyle || $[19] !== userVote || $[20] !== winner.drop.wave) {
    t9 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1"><span className="tw-text-sm"><span className="tw-text-iron-400">Your vote: </span><span className={`tw-font-semibold ${rankStyle}`}>{formatNumberWithCommas(userVote)}{" "}{winner.drop.wave.voting_credit_type}</span></span></div>;
    $[17] = hasUserVoted;
    $[18] = rankStyle;
    $[19] = userVote;
    $[20] = winner.drop.wave;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-3">{t8}{t9}</div>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}